import { BlobModel } from "../../reduxToolkit/blobsSlice"
import { BlobRow, TextractExpenseData } from "../../types/supabase"

export type { TextractExpenseData }

/**
 * The OCR result is now parsed server-side (Blob::deriveExtractedExpense in the
 * admin panel) into blobs.extracted_expense; this used to JSON.parse
 * textract_job_results here, inside a try/catch that only console.error'd on a
 * shape change -- moving it server-side puts a schema change in front of a job
 * that can alarm Sentry instead. See docs/plans/native-app-sdk-seams.md, Cleanup D.
 *
 * `?? null` is a Redux-Persist guard (CLAUDE.md): `extracted_expense` is
 * `undefined` on blobs rehydrated from state persisted before this column
 * existed, and useReceiptSearch maps over every receipt on every render.
 */
export function extractExpenseFromTextract(blob: BlobRow | BlobModel): TextractExpenseData | null {
  return blob.extracted_expense ?? null
}
